import { UPDATE_THREE_D_MODEL_ERROR, UPDATE_THREE_D_MODEL_STARTING, UPDATE_THREE_D_MODEL_SUCCESS } from "../../constants/actionTypes";
import { UPLOAD_MOBILE_TOWER_3D_MODEL } from "../../constants/apiUrls";
import axios from "axios";

export function updateThreeDModelStarting(towerId) {
  return { type: UPDATE_THREE_D_MODEL_STARTING, towerId };
}

export function updateThreeDModelSuccess(towerId,data) {
  return { type: UPDATE_THREE_D_MODEL_SUCCESS,towerId,data };
}

export function updateThreeDModelError(towerId,err) {
  return { type: UPDATE_THREE_D_MODEL_ERROR, towerId,err };
}

export function updateThreeDModel(towerId,updateData) {  
  return (dispatch) => {
    dispatch(updateThreeDModelStarting(towerId));
    const url = UPLOAD_MOBILE_TOWER_3D_MODEL.replace('{towerId}', towerId);
    axios.post(url, updateData)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          dispatch(updateThreeDModelSuccess(towerId,response.data));
          return;
        }

        const err =
          response && response.data && response.data.error
            ? response.data.error
            : "Failed to update data.";
        dispatch(updateThreeDModelError(towerId,err));
      })
      .catch((err) => {
        const error =
          err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : err.message;
        dispatch(updateThreeDModelError(towerId,error));
      });
  };
}